<ion-content>
  <div class="content-wrapper">
    <app-header></app-header>

    <section class="search-filter-bar" *ngIf="filtersLoaded">
      <div>
        <h2 class="aria-element-hidden">Search and Filter Events</h2>

        <uoa-search-autocomplete
          placeholder="Search for events"
          search-button="true"
          search-value=""
          filter-button="true"
          [searchFiltersList]="filter"
          options="[]"
          (filteredArray)="applyFilters($event.detail)"
          (searchedText)="searchEvents($event.detail)"
        ></uoa-search-autocomplete>
      </div>
    </section>

    <div class="inner-content">
      <app-loading-indicator *ngIf="event == undefined"></app-loading-indicator>

      <div class="margin-top-l" *ngIf="event != undefined">
        <div class="margin-top-l">
          <section>
            <ion-breadcrumbs class="breadcrumbs" *ngIf="isMobile()">
              <ion-breadcrumb>
                <ion-button id="detail-trigger-button" (click)="openBreadcrumb()" [ngClass]="{'button-clicked': buttonClicked, 'default-button': !buttonClicked}">
                  <ion-icon name="ellipsis-horizontal"></ion-icon>
                </ion-button>
                <ion-popover trigger="detail-trigger-button" showBackdrop="false" arrow="false" alignment="start" (ionPopoverWillDismiss)="closeBreadcrumb()">
                  <ng-template>
                    <ion-item href="https://www.auckland.ac.nz" class="custom-popover">Home</ion-item>
                    <ion-item href="https://www.auckland.ac.nz/news" class="custom-popover">News and events</ion-item>
                    <ion-item href="/" class="custom-popover">University events</ion-item>
                  </ng-template>
                </ion-popover>
              </ion-breadcrumb>
              <ion-breadcrumb [href]="getCurrentUrl()">
                {{event.name}}
              </ion-breadcrumb>
            </ion-breadcrumbs>
            <ion-breadcrumbs class="breadcrumbs" *ngIf="!isMobile()">
              <ion-breadcrumb href="https://www.auckland.ac.nz">
                Home
              </ion-breadcrumb>
              <ion-breadcrumb href="https://www.auckland.ac.nz/news">
                News and events
              </ion-breadcrumb>
              <ion-breadcrumb href="/">
                University events
              </ion-breadcrumb>
              <ion-breadcrumb [href]="getCurrentUrl()">
                {{event.name}}
              </ion-breadcrumb>
            </ion-breadcrumbs>
          </section>
          <ion-grid *ngIf="isDesktop()" class="event-container">
            <ion-row>
              <ion-col size="8" class="ion-no-padding border-left-light-2 border-top-light-2">
                <ion-img
                  *ngIf="event.imageUrl"
                  class="event-image"
                  [src]="event.imageUrl"
                  [ngClass]="{'image-sold-out': event.isSoldOut, 'grid-background': !event.isSoldOut}"
                ></ion-img>
              </ion-col>
              <ion-col
                class="event-info ion-no-padding border-right-light-2 border-top-light-2"
                [ngClass]="{'text-sold-out': event.isSoldOut, 'grid-background': !event.isSoldOut}"
              >
                <div *ngIf="event.startDateTime" class="event-date-month font-xl">
                  {{getEventDate()}}
                  <br>
                  {{getEventTime()}}
                </div>
                <div class="event-title font-xl">{{event.name}}</div>
                <div class="font-default">
                  Organised by <br />
                  {{event.organisationName}}
                </div>
                <div class="contact-organiser font-default">
                  <a href="{{event.organiserUrl}}">Contact organiser</a>
                </div>
                <div class="event-price font-default" *ngIf="event.isFree">Free</div>
                <div class="event-price font-default" *ngIf="!event.isFree">{{event.getPriceDisplay()}}</div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="8" class="ion-no-padding grid-background border-bottom-light-2 border-left-light-2"> </ion-col>
              <ion-col class="ion-no-padding grid-background border-bottom-light-2 border-right-light-2">
                <div class="wrapper">
                  <button *ngIf="event.isFree && !event.isSoldOut" class="uoa-btn btn-dark-blue-inverse btn-wide">
                    <div (click)="checkout()">
                      <p class="uoa-btn-text">Register</p>
                    </div>
                  </button>
                  <button *ngIf="!event.isFree && !event.isSoldOut" class="uoa-btn btn-dark-blue btn-wide">
                    <div (click)="checkout()">
                      <p class="uoa-btn-text">Buy tickets</p>
                    </div>
                  </button>
                  <button *ngIf="event.isSoldOut" class="uoa-btn btn-disabled btn-wide">
                    <div>
                      <p class="uoa-btn-text">Sold out</p>
                    </div>
                  </button>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="8" class="ion-no-padding grid-background details-container border-left-light-2 border-bottom-light-2 font-default" [innerHTML]="event.description"></ion-col>
              <ion-col class="ion-no-padding grid-background event-date-location-container border-right-light-2 border-bottom-light-2 font-default">
                <div *ngIf="getEventDate()" class="event-date-time">
                  <b>Date and time:</b><br>
                  {{getEventDate()}}
                  <br>
                  {{getEventTime()}}
                </div>
                <div *ngIf="event.location">
                  <b>Location:</b><br />
                  <span *ngIf="event.location.name === 'Online'; else displayLocation">Online event</span>

                  <ng-template #displayLocation>
                    {{event.location.name}}<br>
                    <span *ngIf="event.location.address1;">{{event.location.address1}}<br></span>
                    <span *ngIf="event.location.address2;">{{event.location.address2}}<br></span>
                    <span *ngIf="event.location.city;">{{event.location.city}}<br></span>
                    <a *ngIf="mapUrl" [href]="mapUrl"  target="_blank" title="View map">View map<ion-icon class="map-icon" name="open-outline"></ion-icon></a>
                  </ng-template>                  
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>

          <ion-grid *ngIf="!isDesktop()" class="event-container">
            <ion-row class="ion-no-padding border-left-light-2 border-top-light-2 border-right-light-2">
              <ion-img
                *ngIf="event.imageUrl"
                [src]="event.imageUrl"
                class="event-image"
                [ngClass]="{'image-sold-out': event.isSoldOut, 'grid-background': !event.isSoldOut}"
              ></ion-img>
            </ion-row>
            <ion-row
              class="event-info grid-background-gray ion-no-padding border-left-light-2 border-right-light-2 border-bottom-light-2"
              [ngClass]="{'text-sold-out': event.isSoldOut, 'grid-background': !event.isSoldOut}"
            >
              <div class="event-title font-xl">{{event.name}}</div>
              <div class="font-default">
                Organised by <br />
                {{event.organisationName}}
              </div>
              <div class="contact-organiser font-default">
                <span>
                  <a href="{{event.organiserUrl}}">Contact organiser</a>
                </span>
              </div>
              <div class="event-price font-default" *ngIf="event.isFree">Free</div>
              <div class="event-price font-default" *ngIf="!event.isFree">{{event.getPriceDisplay()}}</div>
            </ion-row>
            <ion-row class="event-date-location-container ion-no-padding border-left-light-2 border-right-light-2 border-bottom-light-2">
              <div *ngIf="getEventDate()" class="event-date-time">
                <ion-icon name="calendar"></ion-icon>
                <p>
                  <b>Date and time:</b><br>
                  {{getEventDate()}}
                  <br>
                  {{getEventTime()}}
                </p>
              </div>
              <div class="event-location">
                <ion-icon name="location-sharp"></ion-icon>
                <p>
                  <b>Location:</b><br />
                  <span *ngIf="event.location.name === 'Online'; else displayLocation">Online event</span>

                  <ng-template #displayLocation>
                    {{event.location.name}}<br>
                    <span *ngIf="event.location.address1;">{{event.location.address1}}<br></span>
                    <span *ngIf="event.location.address2;">{{event.location.address2}}<br></span>
                    <span *ngIf="event.location.city;">{{event.location.city}}<br></span>
                    <a *ngIf="mapUrl" [href]="mapUrl"  target="_blank" title="View map">View map<ion-icon class="map-icon" name="open-outline"></ion-icon></a>
                  </ng-template>  
                </p>                
              </div>
              <div class="details-container-mobile" [innerHTML]="event.description"></div>
            </ion-row>
          </ion-grid>

          <section *ngIf="similarEvents && similarEvents.length > 0" class="similar-events">
            <div class="similar-events-header">
              <h2>Events you might like:</h2>
            </div>
            <app-event-card-grid [events]="similarEvents | slice:0:getSimilarDisplayCount()"></app-event-card-grid>
          </section>

          <div *ngIf="!isDesktop()" class="wrapper">
            <button *ngIf="event.isFree && !event.isSoldOut" class="uoa-btn btn-dark-blue-inverse btn-wide">
              <div (click)="checkout()">
                <p class="uoa-btn-text">Register</p>
              </div>
            </button>
            <button *ngIf="!event.isFree && !event.isSoldOut" class="uoa-btn btn-dark-blue btn-wide">
              <div (click)="checkout()">
                <p class="uoa-btn-text">Buy tickets</p>
              </div>
            </button>
            <button *ngIf="event.isSoldOut" class="uoa-btn btn-disabled btn-wide">
              <div>
                <p class="uoa-btn-text">Sold out</p>
              </div>
            </button>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</ion-content>
